import React, { useState } from "react";
import { MailCheck } from "lucide-react";
import { useNavigate } from "react-router-dom";

const TOKEN_KEY = "ct_login_token";
const USER_KEY = "ct_login_user";
const EMAIL_OTP_TOKEN_KEY = "ct_email_otp_token";

function defaultPathForRole(role) {
  return role === "nexo" ? "/nexo" : role === "secret" ? "/x-portal" : "/";
}

export default function EmailOtpVerify() {
  const navigate = useNavigate();
  const [otpCode, setOtpCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const emailOtpToken = localStorage.getItem(EMAIL_OTP_TOKEN_KEY);

  const submitOtp = async (e) => {
    e.preventDefault();

    if (!emailOtpToken) {
      navigate("/login", { replace: true });
      return;
    }

    setError("");
    setLoading(true);

    try {
      const res = await fetch("/api/2fa/email-otp/verify", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${emailOtpToken}`,
        },
        body: JSON.stringify({ otpCode }),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok || !data.success) {
        throw new Error(data.error || "Invalid email OTP");
      }

      localStorage.setItem(TOKEN_KEY, data.token);
      localStorage.setItem(USER_KEY, JSON.stringify(data.user));
      localStorage.removeItem(EMAIL_OTP_TOKEN_KEY);

      if (["admin", "secret"].includes(data.user?.role)) {
        localStorage.setItem("ct_admin_auth", "true");
      } else {
        localStorage.removeItem("ct_admin_auth");
      }

      navigate(defaultPathForRole(data.user?.role), { replace: true });
    } catch (err) {
      setError(err.message || "Invalid email OTP");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#111827] text-white flex items-center justify-center px-4">
      <form onSubmit={submitOtp} className="w-full max-w-[440px] bg-[#1f2937] rounded-xl px-8 py-8 shadow-2xl">
        <div className="flex flex-col items-center mb-7">
          <div className="w-16 h-16 rounded-full bg-emerald-600 flex items-center justify-center mb-4">
            <MailCheck size={30} />
          </div>
          <h1 className="text-2xl font-bold">Company Email OTP</h1>
          <p className="text-gray-300 text-sm mt-2 text-center">
            Enter the 6-digit OTP sent to your registered business email.
          </p>
        </div>

        <input
          className="w-full bg-[#374151] border border-[#4b5563] rounded-lg py-3 px-3 mb-4 text-center tracking-[0.35em] text-xl"
          placeholder="000000"
          value={otpCode}
          maxLength={6}
          onChange={(e) => setOtpCode(e.target.value.replace(/\D/g, ""))}
        />

        {error && <div className="text-red-300 text-sm mb-4">{error}</div>}

        <button disabled={loading} className="w-full bg-emerald-500 hover:bg-emerald-400 rounded py-3 font-semibold disabled:opacity-60">
          {loading ? "Verifying..." : "Verify Email OTP"}
        </button>
      </form>
    </div>
  );
}